export default "__VITE_ASSET__pHFeMz2M__"